export enum InventoryEnums {
  //Tipo:
  otro = 0,
  ninguno = 1,
  equipos = 2,
  insumos = 3,
  prefabricados = 4
}

export enum InventoryClassCodeEnums {
  rental = 1,
  subrental = 2,
  rawMaterial = 3,
  sales = 4
}

export enum InventoryCodeEnums {
  subrental = 0,
  rental = 1,
  sales = 2
}